/* @flow */

import clsx from 'clsx';
import * as React from 'react';

import Localizer from '../../helpers/localization';
import { PictoKid, PictoLock } from '../pictos/Element';
import './ProfileTypeIndicator.css';

export enum ProfileType {
  Kid,
  Private,
}

type KidProfileIndicatorPropType = {
  +outlined?: boolean,
  +profileType: ProfileType,
};

const ProfileTypeIndicator = ({ outlined = false, profileType }: KidProfileIndicatorPropType): React.Node => {
  const picto = profileType === ProfileType.Kid ? <PictoKid aria-hidden /> : <PictoLock aria-hidden />;
  const textKey = profileType === ProfileType.Kid ? 'profiles.profile_editor.kid_profile' : 'profiles.profile_editor.privacy.private_profile';

  return (
    <div className={clsx('profileTypeIndicator', outlined && 'outlined')}>
      {picto}
      <div className='profileTypeIndicatorText'>{Localizer.localize(textKey)}</div>
    </div>
  );
};

export default ProfileTypeIndicator;
